<ng-container *transloco="let t">
<ion-content>
	<div>
		<ion-card class="m-0">
			<ion-card-header class="popin-header">
				<ion-card-title>
					<ion-icon (click)="closePopover()" class="m-2 popin-close" name="close-outline">
					</ion-icon>
				</ion-card-title>
			</ion-card-header>
			<ion-card-content>
				<ion-grid class="h-100">
					<ion-row>
						<ion-row>
							<ion-col class="my-thin-col">
								<ion-img [src]="profile().imgUrl" alt="User avatar" class="card-img"/>
							</ion-col>
							<ion-col>
								<ion-row>
									<span class="online text-center me-1 mt-auto mb-auto">
										<ion-icon [ngClass]="statusClass()" class="is-offline" name="ellipse"></ion-icon>
									</span>
									<h2 class="popin-name">
										@if (profile().username.length > 16) {
											{{ profile().username | slice : 0 : 16 }}...


										} @else {
											{{ profile().username }}
										}
									</h2>
								</ion-row>
								<ion-row>
									<span
										class="me-auto d-flex">{{t("gender." + gender2LabelMapping[profile().gender])}}
											<ion-text>
												@if (profile().pronoun.length) {
													(
													@for (p of profile().pronoun; track p; let last = $last) {
														{{t("pronoun." + pronouns2LabelMapping[p])}}{{ last ? '' : ',' }}
													}
													)
												}
											</ion-text>
										@if (profile().transPeople) {
											<img alt="Transgender flag" class="title-image trans-flag" height="20"
											     [ngSrc]="'assets/icons/transFlag.svg'"
											     width="20"/>
										}

										{{ profile().age }} {{t("yearsold")}}
									</span>
								</ion-row>
								<ion-row>
									<span class="me-auto">{{t("roles." + roles2LabelMapping[profile().role])}}</span>
								</ion-row>
							</ion-col>
						</ion-row>
						<div class="w-100 mt-3 d-flex">
							<span class="location-text">{{ profile().region }}
								@if (profile().region !== '') {
									{{ ',' }}
								}
								{{t("country." + profile().pays)}}</span>
							<div class="d-flex action-group">
								@if (profile().uuid !== profileService.currentUid) {
									<span (click)="sendPrivateMessage(profile())" (keyup.enter)="sendPrivateMessage(profile())" tabindex="0"
									      class="m-1 span-icon action-item action-item--message" title="{{t('Send message to user')}}">
										<ion-icon class="red-text icon-static"
										          name="mail-outline"></ion-icon>
									</span>
								}
								<span (click)="openBigProfile(profile())" (keyup.enter)="openBigProfile(profile())" tabindex="0" class="m-1 span-icon"
								      title="{{t('Show full user profile')}}">
									<ion-icon class="red-text icon-static"
									          name="person-outline"></ion-icon>
								</span>
								@if (profile().uuid !== profileService.currentUid) {
									@if (profile().isFavorite) {
										<span (click)="removeUserFavorit()" (keyup.enter)="removeUserFavorit()" tabindex="0" class="m-1 span-icon"
										      title="{{t('Remove user from favorites')}}">
										<ion-icon class="star-color icon-static" name="star"></ion-icon>
									</span>
									} @else {
										<span (click)="addUserFavorit()" (keyup.enter)="addUserFavorit()" tabindex="0" class="m-1 span-icon"
										      title="{{t('Add user to favorites')}}">
										<ion-icon class="red-text icon-static" name="star-outline"></ion-icon>
									</span>
									}
									@if (profile().isBlocked) {
										<span (click)="unblockUser()" (keyup.enter)="unblockUser()" tabindex="0" class="m-1 span-icon" title="{{t('Unblock user')}}">
										<ion-icon name="ban-outline"
										          class="icon-muted icon-static"></ion-icon>
									</span>
									} @else {
										<span (click)="blockUser()" (keyup.enter)="blockUser()" tabindex="0" class="m-1 span-icon" title="{{t('Block user')}}">
											<ion-icon [icon]="'ban-outline'" class="red-text icon-static"></ion-icon>
										</span>
									}
								}
							</div>
						</div>
					</ion-row>
					<ion-row>
						@if (profile().shortDesc) {
							<p class="mt-2"><span class="">"</span>{{ profile().shortDesc }}<span class="">"</span></p>
						} @else {
							<p class="mt-2"><span class="">"</span>{{t('profile.default_mood')}}<span class="">"</span></p>
						}
					</ion-row>
				</ion-grid>
			</ion-card-content>
		</ion-card>
	</div>
</ion-content>

</ng-container>
